import { useCallback } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Popover from '@rio-cloud/rio-uikit/Popover';

import {
    tooltipMarginClassName,
    tooltipSpacerClassNames,
    tooltipWrapperClassNames,
} from '@/features/batteryOverview/utils/BatteryDataUtils';
import { isNumeric } from '../utils/NumberUtils';

type BatteryDetailRowType = {
    name: string;
    value: number | string | undefined;
    unit: string;
    tooltipMsg?: string;
};

export const BatteryDetailsRow = ({ name, value, unit, tooltipMsg }: BatteryDetailRowType) => {
    const rowTooltip = useCallback(
        (title: string, body: string) => (
            <Popover id={'axleinfo-popover'} className={tooltipMarginClassName} placement={'auto'}>
                <div className={tooltipWrapperClassNames}>
                    <div className={'h6'}>
                        <FormattedMessage id={title} />
                    </div>
                    <hr className={tooltipSpacerClassNames} />
                    <span>
                        <FormattedMessage id={body} />
                    </span>
                </div>
            </Popover>
        ),
        [],
    );

    const renderValue = () => {
        if (value !== undefined) {
            if (isNumeric(value)) {
                return (
                    <>
                        <FormattedNumber value={value} />
                        {unit}
                    </>
                );
            }

            // not a number, so it is a string
            if (value.trim() !== '') {
                return (
                    <>
                        {value} {unit}
                    </>
                );
            }
        }

        return (
            <span className="text-color-gray">
                <FormattedMessage id="intl-msg:batteryService.noData" />
            </span>
        );
    };

    return (
        <div className={'row'}>
            <div className={'col-6 text-color-darkest font-300'}>
                <span>
                    <FormattedMessage id={name} />
                </span>
                {tooltipMsg !== undefined && (
                    <span className={tooltipMarginClassName}>
                        <OverlayTrigger overlay={rowTooltip(name, tooltipMsg)} placement={'right'}>
                            <span className="rioglyph rioglyph-info-sign margin-left-5 text-color-dark" />
                        </OverlayTrigger>
                    </span>
                )}
            </div>
            <div className="col-6 text-color-darkest text-left">
                <span>{renderValue()}</span>
            </div>
        </div>
    );
};
